// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-upload-container {
  max-width: 600px;
  margin: 2rem auto;
  padding: 2rem;
  border: 1px solid #ddd;
  border-radius: 12px;
  background: #f9f9f9;
}

.video-upload-container h2 {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  font-weight: bold;
}

.video-upload-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.video-upload-form input[type="text"],
.video-upload-form input[type="number"],
.video-upload-form input[type="file"],
.video-upload-form textarea {
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.video-upload-form > .btn {
  background-color: #007bff;
  color: white;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.video-upload-form > .btn:hover {
  background-color: #0056b3;
}

.upload-message {
  margin-top: 1rem;
  font-weight: bold;
}

.upload-progress {
  margin-top: 1rem;
}

.tiptap {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 1rem;
  min-height: 150px;
  margin-bottom: 1rem;
}

.tiptap {
  min-height: 200px;
  padding: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  font-size: 1rem;
  margin-bottom: 1rem;
}

/* .toolbar {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
} */

/* .toolbar button {
  padding: 0.4rem 0.8rem;
  background: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}

.toolbar button:hover {
  background: #e0e0e0;
} */

`, "",{"version":3,"sources":["webpack://./src/component/App.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;;EAIE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;GAIG;;AAEH;;;;;;;;;;GAUG","sourcesContent":[".video-upload-container {\n  max-width: 600px;\n  margin: 2rem auto;\n  padding: 2rem;\n  border: 1px solid #ddd;\n  border-radius: 12px;\n  background: #f9f9f9;\n}\n\n.video-upload-container h2 {\n  font-size: 1.5rem;\n  margin-bottom: 1.5rem;\n  font-weight: bold;\n}\n\n.video-upload-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.video-upload-form input[type=\"text\"],\n.video-upload-form input[type=\"number\"],\n.video-upload-form input[type=\"file\"],\n.video-upload-form textarea {\n  padding: 10px;\n  font-size: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n}\n\n.video-upload-form > .btn {\n  background-color: #007bff;\n  color: white;\n  padding: 0.75rem 1rem;\n  font-size: 1rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.video-upload-form > .btn:hover {\n  background-color: #0056b3;\n}\n\n.upload-message {\n  margin-top: 1rem;\n  font-weight: bold;\n}\n\n.upload-progress {\n  margin-top: 1rem;\n}\n\n.tiptap {\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 1rem;\n  min-height: 150px;\n  margin-bottom: 1rem;\n}\n\n.tiptap {\n  min-height: 200px;\n  padding: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background: #fff;\n  font-size: 1rem;\n  margin-bottom: 1rem;\n}\n\n/* .toolbar {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n} */\n\n/* .toolbar button {\n  padding: 0.4rem 0.8rem;\n  background: #f0f0f0;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.toolbar button:hover {\n  background: #e0e0e0;\n} */\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
